<app-theme-single-color-item
  [gallery]="gallery()"
  title="Overlay"
  [icon]="'/assets/icons/color-fill.svg'"
  [color]="theme().cover.overlay_color"
  [allowOpacity]="true"
  (colorChange)="updateCoverOverlay($event)"
></app-theme-single-color-item>
